export enum ProgramTabs {
  Overview = 'overview',
  Reporting = 'reporting',
  Settings = 'settings',
  Participants = 'participants'
}
